import { en } from "./en";
import { ar } from "./ar";
import { ru } from "./ru";

const localization = {
  en,
  ar,
  ru,
};

export default localization;
